import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-card-summary',
  templateUrl: './av-card-summary.component.html',
  styleUrls: ['./av-card-summary.component.scss']
})
export class AvCardSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
